import(/* webpackMode: "eager" */ "/vercel/path0/apps/web/src/app/pages/contact/page.jsx");
